__turbopack_context__.v({
  "className": "archivo_700a2580-module__UD7JIa__className",
});
